import $ from 'jquery';
import { Loader } from '@googlemaps/js-api-loader';

const loader = new Loader({
    apiKey: "AIzaSyDBM5NknixL9Hofr2XmB7LEKcDaUKus8KE",
    version: "weekly",
    libraries: ["places"]
});
let $body = $('body');
let map;
let markers = [];;
if ($('.js-location-block').length) {
    $body.on('click', '.js-location-block .locationBlock__header', (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $this.closest('.js-location-block').toggleClass('active');
        $this.closest('.js-location-block').find('.locationBlock__details').slideToggle();
    });

    loader.load().then((google) => {
        let $map = $('.js-locator-map');
        let bounds = new google.maps.LatLngBounds();
        let mapOptions = {
            zoom: 5,
            center: new google.maps.LatLng(-25.4394215, 130.3294084),
            backgroundColor: 'hsla(0, 0%, 0%, 0)',
            disableDefaultUI: true,
        };

        map = new google.maps.Map($map[0], mapOptions);

        $('.js-location-block').each((index, location) => {

            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(parseFloat(location.dataset.lat), parseFloat(location.dataset.lng)),
                // icon: {
                //     url: `themes/imagine/dist/images/standard/poi.png`,
                //     size: new google.maps.Size(38, 50),
                //     scaledSize: new google.maps.Size(38, 50)
                // }
            });
            bounds.extend(marker.getPosition());
            map.fitBounds(bounds);
            marker.setMap(map);

            marker.addListener('click', function () {
                $(`.js-location-block[data-id="${location.dataset.id}"]`).trigger('click')
            });

            let zoom = map.getZoom();
            map.setZoom(zoom > 17 ? 17 : zoom);

        });

    });


}